import { render, staticRenderFns } from "./DashboardTable.vue?vue&type=template&id=483bfd8c&scoped=true"
import script from "./DashboardTable.vue?vue&type=script&lang=js"
export * from "./DashboardTable.vue?vue&type=script&lang=js"
import style0 from "./DashboardTable.vue?vue&type=style&index=0&id=483bfd8c&prod&scoped=true&lang=css"
import style1 from "./DashboardTable.vue?vue&type=style&index=1&id=483bfd8c&prod&lang=scss"
import style2 from "./DashboardTable.vue?vue&type=style&index=2&id=483bfd8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483bfd8c",
  null
  
)

export default component.exports